import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgPureDatatableComponent } from './ng-pure-datatable.component';
import {NgPureDataTableEventService} from './ng-pure-datatable-event.service';
import {NgPaginateComponent} from './ng-paginate/ng-paginate.component';
import {NgSearchComponent} from './ng-search/ng-search.component';
import {NgSearchService} from './ng-search/ng-search.service';
import {NgPaginateService} from './ng-paginate/ng-paginate.service';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
export class NgPureDatatableModule {
/**
 * @return {?}
 */
static forRoot() {
    return {
      ngModule: NgPureDatatableModule,
      providers: [NgPureDataTableEventService, NgSearchService, NgPaginateService]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [NgPureDatatableComponent, NgPaginateComponent, NgSearchComponent],
  exports: [NgPureDatatableComponent, NgPaginateComponent, NgSearchComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgPureDatatableModule_tsickle_Closure_declarations() {
/** @type {?} */
NgPureDatatableModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPureDatatableModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
